import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EventFailureTicketsButton from '../eventFailureTickets/EventFailureTicketsButton';
import TestHistoryExportButton from '../TestHistoryExportButton';
import TestHistorySortSelect from './TestHistorySortSelect';
import { testHistoryToolbarStyles } from './styles';

export default function TestHistoryToolbar({
  results,
  allResults,
  totalResults,
  sortBy,
  onSortChange,
  aiLoading,
  regressionId,
  onAIAnalysis,
  hasActiveFilters,
  searchFilters,
}) {
  const handleSortChange = (value) => {
    onSortChange('sortBy', value);
  };

  return (
    <Box sx={testHistoryToolbarStyles.root}>
      <Typography variant="h6">
        {totalResults && totalResults !== results.length
          ? `Showing ${results.length} of ${totalResults} test result${totalResults !== 1 ? 's' : ''}`
          : `Found ${results.length} test result${results.length !== 1 ? 's' : ''}`}
      </Typography>

      <Box sx={testHistoryToolbarStyles.actions}>
        <TestHistorySortSelect value={sortBy} onChange={handleSortChange} />

        <Button
          variant="outlined"
          color="secondary"
          startIcon={<AutoAwesomeIcon />}
          onClick={onAIAnalysis}
          disabled={aiLoading || !regressionId}
          sx={testHistoryToolbarStyles.aiButton}
        >
          {aiLoading ? 'Analyzing...' : 'AI Analysis'}
        </Button>

        <EventFailureTicketsButton searchFilters={searchFilters || {}} />

        <TestHistoryExportButton
          allResults={allResults || []}
          filteredResults={results || []}
          hasActiveFilters={hasActiveFilters}
          disabled={!results || results.length === 0}
          regressionTestId={allResults?.[0]?.regression_test_id || ''}
          searchFilters={searchFilters || {}}
        />
      </Box>
    </Box>
  );
}
